// store — en. MyStore seller product manager and the Submit content-upload page.
export default {
  storeErrNameRequired: 'Product name is required.',
  storeErrCategoryRequired: 'Category is required.',
  storeErrPriceInvalid: 'Price must be greater than zero.',
  storeErrStockInvalid: 'Stock must be zero or greater.',
  storeErrImageRequired: 'Please add at least one product image.',
  storeErrMaxPhotos: 'Maximum 5 photos allowed.',
  storeSaveFailed: 'Save failed.',
  storeDeleteFailed: 'Delete failed.',
  storeSalePrice: 'Sale Price (ETB) — leave empty for no discount',
  storeSelectCategory: 'Select category...',
  storeSubcategory: 'Subcategory',
  storeSelectSubcategory: 'Select subcategory...',
  storeIsPackage: '📦 This is a Package / Bundle',
  storePackageIntro: 'Add items included in this package:',
  storePackageItemName: 'Item name',
  storePackageAddItem: '+ Add Item to Package',
  storeAvailableColors: 'Available Colors',
  storeTapCircles: '(tap the circles to pick)',
  storeAllColors: '🎨 Available in all colors',
  storeShowInBazaar: '🛍️ Show in Bazaar',
  storeBazaarNote: '(also listed during scheduled Bazaar windows — product always appears on the Market page)',
  storeProductImages: 'Product Images *',
  storeUpToPhotos: '(up to 5 photos)',
  storeCurrentPhotos: 'Current photos:',
  storeUploadingPhotos: 'Uploading photos...',
  storePackageBadge: 'PACKAGE',
  storeStockLabel: 'Stock',
  storeAwaitingApproval: '⏳ Awaiting admin approval',

  subImgCountErr: 'Select between 3 and 5 images.',
  subVidCountErr: 'Select between 3 and 5 videos.',
  subVidDurationErr: 'Each video must be under 1 minute.',
  subNameRequired: 'Each path must have a name.',
  subPathImages: (name) => `"${name}": select 3–5 images.`,
  subPathVideos: (name) => `"${name}": select 3–5 videos.`,
  subFixErrors: 'Please fix file errors before submitting.',
  subFailed: 'Submission failed. Please try again.',
  subSuccessTitle: 'Submitted Successfully!',
  subSuccessMsg: 'Our team will review your content and get back to you.',
  subSubmitAnother: 'Submit Another',
  subPageTitle: 'Submit Your Content',
  subPageIntro: 'Upload your marketing content for each path.',
  subRules: '📋 Rules: Each path requires 3–5 images and 3–5 videos. Each video must be under 1 minute.',
  subPathHeading: (n) => `Path ${n}`,
  subRemove: 'Remove',
  subPathName: 'Path Name *',
  subPathNamePlaceholder: 'e.g. Summer Campaign',
  subDescription: 'Description (optional)',
  subDescPlaceholder: 'Brief description of this content...',
  subImagesLabel: 'Images (3–5) *',
  subImagesSelected: (n) => `✓ ${n} image${n > 1 ? 's' : ''} selected`,
  subVideosLabel: 'Videos (3–5, max 1 min each) *',
  subVideosSelected: (n) => `✓ ${n} video${n > 1 ? 's' : ''} selected`,
  subAddPath: '+ Add Another Path',
  subSubmitting: 'Submitting...',
  subSubmitPaths: (n) => `Submit ${n} Path${n > 1 ? 's' : ''}`,
};